module.exports = __webpack_public_path__ + "img/jdymx.cf670489.jpg";